export { default } from './CarouselDots';
